export const UWM_NAVIGATE_TYPES = {
    PAUSE_MODE: 'PAUSE_MODE',
    UWM_MODULE_NAVIGATE_TO_TIPS: 'UWM_MODULE_NAVIGATE_TO_TIPS',
    UWM_MODULE_NAVIGATE_TO_DEVICE_PERSONALIZE: 'UWM_MODULE_NAVIGATE_TO_DEVICE_PERSONALIZE',
} as const;
